<script lang="ts">
	import Layout from './Layout.svelte';
	import { onMount } from 'svelte';
	import SplashScreen from './Screens/SplashScreen.svelte';
	import { screenWidth } from './stores/hover';
	onMount(() => {
		$screenWidth = window.innerWidth;
	});
</script>

<svelte:window on:resize={(e) => ($screenWidth = window.innerWidth)} />
<Layout>
<SplashScreen />
</Layout>